import { useEffect, useState } from "react";

const CursorReticle = () => {
  const [pos, setPos] = useState({ x: -100, y: -100 });
  const [label, setLabel] = useState(null);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const fine = window.matchMedia("(pointer: fine)").matches;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!fine || reduced) return;
    setEnabled(true);
    const move = (e) => setPos({ x: e.clientX, y: e.clientY });
    const over = (e) => {
      const t = e.target.closest && e.target.closest("[data-cursor]");
      setLabel(t ? t.dataset.cursor : null);
    };
    window.addEventListener("mousemove", move, { passive: true });
    window.addEventListener("mouseover", over, { passive: true });
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
    };
  }, []);

  if (!enabled) return null;
  return (
    <div
      aria-hidden="true"
      className="fixed z-[95] pointer-events-none"
      style={{ left: pos.x, top: pos.y, transform: "translate(-50%, -50%)" }}
    >
      <div
        className={`border transition-all duration-200 ${
          label ? "w-9 h-9 border-arc-cyan/80 rotate-45" : "w-5 h-5 border-arc-cyan/40"
        }`}
        style={{ borderRadius: 0 }}
      />
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-1 h-1 bg-arc-cyan/80" />
      {label && (
        <div className="absolute top-full mt-2 left-1/2 -translate-x-1/2 font-mono text-[9px] tracking-[0.25em] text-arc-cyan whitespace-nowrap">
          {label}
        </div>
      )}
    </div>
  );
};

export default CursorReticle;
